import React from 'react';
import { Box, Typography, Chip, Stack } from '@mui/material';
import {
  resolveApiPresenceStatus,
  resolveEnrollmentLifecycleStatus,
} from '../utils/enrollmentEvidence';
import { getApiPresenceStatusMeta } from '../utils/status';

const pillSx = { height: 20, fontSize: '0.75rem' };

export default function SearchPreview({ option }) {
  if (!option) return null;
  const label = option.label || option.value || '';
  const meta = option.meta || null;

  if (!meta) {
    return (
      <Box sx={{ py: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
      </Box>
    );
  }

  const dealerName = meta.dealerName || '';
  const bac = meta.bac || '';
  const programName = meta.programName || '';
  const status = resolveEnrollmentLifecycleStatus(meta);
  const apiPresence = resolveApiPresenceStatus(meta);
  const apiPresenceMeta = apiPresence ? getApiPresenceStatusMeta(apiPresence) : null;

  return (
    <Box sx={{ py: 0.5, width: '100%' }}>
      <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
        {dealerName || label}
      </Typography>
      <Stack direction="row" spacing={0.75} sx={{ mt: 0.5, flexWrap: 'wrap' }}>
        {bac ? <Chip label={`BAC ${bac}`} size="small" sx={pillSx} variant="outlined" /> : null}
        {programName ? <Chip label={programName} size="small" sx={pillSx} variant="outlined" /> : null}
        {status ? <Chip label={status} size="small" sx={pillSx} color="primary" variant="outlined" /> : null}
        {apiPresenceMeta ? (
          <Chip
            label={`API ${apiPresenceMeta.label}`}
            size="small"
            sx={pillSx}
            color={apiPresenceMeta.color === 'default' ? undefined : apiPresenceMeta.color}
            variant="outlined"
          />
        ) : null}
      </Stack>
    </Box>
  );
}

